import { AppState, appReducer } from './app';
import { AuditState, auditReducer } from './audit';
import { CacheState, cacheReducer } from './cache';
import { TenantState, tenantReducer } from './tenant';
import { SettingsState, settingsReducer } from './setting';
import { UserState, userReducer } from './user';

import { applyMiddleware, createStore } from 'third-party';

import { getUserToken } from 'utils/auth';
import { combineReducers, compose, middlewareBuilder } from 'utils/sra';

export type State = {
  app: AppState;
  audit: AuditState;
  tenant: TenantState;
  user: UserState;
  cache: CacheState;
  settings: SettingsState;
};

// custom middleware for web requests
const middleWare = [
  middlewareBuilder({
    httpRequestHandler: async (url: string, options?: Partial<RequestInit>) => {
      const isFormData = options?.body instanceof FormData;

      const headers: Record<string, string> = {
        Authorization: getUserToken(),
      };

      // Only add Content-Type if not FormData
      if (!isFormData) {
        headers['Content-Type'] = 'application/json';
        headers['accept'] = 'application/json';
        headers['client-os'] = 'web';
      }

      // Merge with any custom headers
      const mergedHeaders = {
        ...headers,
        ...options?.headers,
      };

      return await fetch(url, {
        ...options,
        headers: new Headers(mergedHeaders),
      });
    },
  }),
];
// added support for redux-dev tool
export const composeEnhancers =
  (window && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

// create store for redux
export const combinedReducer = combineReducers({
  app: appReducer,
  audit: auditReducer,
  user: userReducer,
  cache: cacheReducer,
  tenant: tenantReducer,
  settings: settingsReducer,
});

export const store = createStore(
  combinedReducer,
  composeEnhancers(applyMiddleware(...middleWare)),
);
